/**
 * Build metadata sourced from Vite's `import.meta.env`. CI injection of
 * real version / build / patch values is future work — see SPEC
 * `2026-07-10-about-section/PRD.md` § Risks and Open Questions. Today we
 * ship with stable fallbacks so SSR, dev, and production all render
 * usable text without crashing on a missing env var.
 *
 * Exposed via the standard `import.meta.env` interface so that future
 * `chore/build-info-injection` work can wire `VITE_APP_VERSION` /
 * `VITE_APP_BUILD` / `VITE_APP_PATCH` from the CI shell without touching
 * this file.
 */
export type BuildInfo = {
  version: string;
  build: string;
  patch: string;
};

const env = import.meta.env;

export const buildInfo: BuildInfo = {
  version: env.VITE_APP_VERSION ?? '0.1.0',
  build: env.VITE_APP_BUILD ?? '0',
  patch: env.VITE_APP_PATCH ?? 'dev'
};

/**
 * Render the canonical `"version (Build: N) Patch: hash"` string. This is
 * what the version card copies to the clipboard and what the feedback
 * button carries into the support hand-off.
 */
export function buildInfoString(info: BuildInfo = buildInfo): string {
  return `${info.version} (Build: ${info.build}) Patch: ${info.patch}`;
}
